<app-header-latest></app-header-latest>
<div class="container padding-y-80 d-flex justify-content-center align-items-center min-vh-80">
  <div class="download-section text-center">
    <p class="check-mark"><i class="fa-solid fa-circle-check"></i></p>
    <!-- <img class="success-gif" src="../../../assets/images/success-tick-img2.gif" /> -->
    <div class="row">

      <div class="col-lg-6 offset-lg-3 text-center">
        <h5 class="px-lg-5 fw-bold" style="font-size: 2.5rem !important;">CONGRATULATIONS</h5>

        <!-- <p>{{ supportMessage }}</p> -->
        <!-- <h3 style="font-size: 1.5rem;"> Registration is successful.</h3> -->
         <h3 style="font-size: 1.5rem;margin-top: 5%;" *ngIf="vendorData?.data?.referral_code"> Your Ref Id: {{ vendorData?.data?.reg_id }}</h3>
        <h3 style="font-size: 1rem;">An email is sent to <span class="primary-color">"{{maskedEmail}}"</span> for verification.</h3>
        <!-- <h3 style="font-size: 1rem;">
            Please upload respective documents to finish your profile completion.
            <a (click)="goTo('/support-documents')"> <span class="primary-color" style="cursor:pointer;">Click here</span>
            </a>
        </h3> -->
          <!-- <h3 style="font-size: 1rem;">Please click here to <a
            (click)="goTo('/sign-in')"><span class="primary-color" style="cursor: pointer;">Login.</span></a></h3> -->

      </div>
    </div>

    <!-- <h6 style="margin-top: 2%;font-size: 1rem;">Please click here to  <a  (click)="goTo('/sign-in')"><span class="primary-color" style="cursor: pointer;">Login.</span></a></h6> -->
    <!-- <button type="button" style="margin-top: 2%;" class="btn btn-solid _button" (click)="goTo('/sign-in')">Login</button> -->
    <!-- div class="d-flex justify-content-center">
              
            </div> -->
    <!-- <p class="section-title px-lg-5">{{ supportMessage }}</p> -->
    <!-- <div>
          <button type="button" class="btn btn-solid _button" (click)="goTo('/sign-in')">Login</button>
        </div> -->
    <!-- <div class="theme-card text-center">
            

            <div style="display: flex; width: 100%;">

              <div style="width: 60%;margin-top: 4%; display: inline-flex;">
              </div>
              <div style="width: 40%;">
                <button type="button" class="btn btn-solid _button" (click)="goTo('/sign-in')">Login</button>
              </div>
            </div>
            <div class="row mt-4 justify-content-between">
            </div>
          </div> -->
    <!-- <h3 class="error-heading">Please login again. <a  (click)="goTo('/sign-in')">Click here</a></h3> -->

  </div>
</div>
<!-- <section class="login-page section-b-space">
  <div class="container">
    <div class="custom-form">
      <div class="row justify-content-center">
        <div class="col-lg-6">
          <div class="theme-card text-center">
            <div class="d-flex justify-content-center">
              <img
                class="success-gif"
                src="../../../assets/images/success.gif"
              />
            </div>
            <p>{{ supportMessage }}</p>

            <div style="display: flex; width: 100%;">

              <div style="width: 60%;margin-top: 4%; display: inline-flex;">
                
              </div>
              <div style="width: 40%;">
                <button type="button" class="btn btn-solid _button" (click)="goTo('/sign-in')">Login</button>
              </div>
            </div>
            <div class="row mt-4 justify-content-between">


             
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section> -->
<app-footer-more-info></app-footer-more-info>